// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Ahw3Q","title":"ClientReferral_title__1VfA_","itemText":"ClientReferral_itemText__186JQ"};